import React, { useEffect, useState } from 'react';
import { Loader } from '../../../Common';
import { Container } from 'reactstrap';
import BreadcrumbTrail from '../../../Common/BreadcrumbTrail';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import Table from './Components/Table/Table';
import { Constant } from '../../../Helpers/constant';
import { DOWNLOAD_LIST_V2 } from '../../../../store/actions';

const DownloadsV2 = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  // Parse URL query parameters
  const { page = 1, perPageLimit = Constant.TABLE_PAGE_SIZE } = queryString.parse(location.search);

  const [currentPageNumber, setCurrentPageNumber] = useState(Number(page) - 1); // `page` is 1-based
  const [rowsPerPage, setRowsPerPage] = useState(Number(perPageLimit));
  const [loading, setLoading] = useState(false);

  // Voucher Booking
  const { downloadsV2, downloadsLoadingV2 } = useSelector((state: any) => ({
    downloadsV2: state?.DwonloadListV2?.data,
    downloadsLoadingV2: state?.DwonloadListV2?.loading,
  }));

  useEffect(() => {
    // Sync state with URL
    const { page, perPageLimit } = queryString.parse(location.search);
    setCurrentPageNumber(Number(page || 1) - 1); // Default to 1-based page
    setRowsPerPage(Number(perPageLimit || Constant.TABLE_PAGE_SIZE));
  }, [location.search]);

  useEffect(() => {
    dispatch({
      type: DOWNLOAD_LIST_V2,
      payload: {
        urlParams: {
          skip: currentPageNumber * rowsPerPage,
          limit: rowsPerPage,
        },
      },
    });
  }, [currentPageNumber, rowsPerPage, dispatch]);

  useEffect(() => {
    if (downloadsLoadingV2) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [downloadsLoadingV2]);

  const updateURLParams = newParams => {
    const currentParams = queryString.parse(location.search);

    const updatedParams = {
      page: currentPageNumber + 1, // Default to current page
      perPageLimit: rowsPerPage, // Default to current rowsPerPage
      ...currentParams, // Merge existing query parameters
      ...newParams, // Override with new parameters
    };

    const newUrl = queryString.stringify(updatedParams);

    history.push({
      pathname: location.pathname,
      search: `?${newUrl}`,
    });
  };

  const paginationHandler = pageNumber => {
    updateURLParams({ page: pageNumber + 1 });
  };

  const handleRowsPerPageChange = newRowsPerPage => {
    updateURLParams({ page: 1, perPageLimit: newRowsPerPage });
  };

  /* ---------------------------- BREADCRUMB HANDLER ---------------------------- */
  const breadcrumNavigationHandler = title => {
    if (title === `Dashboard`) {
      history.push(`/dashboard`);
    }
  };

  /* ---------------------------- TABLE ACTION HANDLER ---------------------------- */
  const tableActionHandler = params => {
    if (params?.actionType === `DOWNLOAD`) {
      window.open(params?.downloadDetails?.file, `_blank`);
    }
  };

  return (
    <>
      {loading && <Loader />}

      <div className="page-content">
        <Container fluid className="position-relative">
          <div id="main-voucher-container">
            <BreadcrumbTrail title="Downloads" navigationby={breadcrumNavigationHandler} navigation={[`Dashboard`, `Downloads`]} />
          </div>

          <Table
            data={downloadsV2?.results}
            totalCount={downloadsV2?.total_count}
            pageNumber={currentPageNumber}
            limit={rowsPerPage}
            handleRowsPerPageChange={handleRowsPerPageChange}
            handlePageChange={paginationHandler}
            actionHandler={tableActionHandler}
          />
        </Container>
      </div>
    </>
  );
};

export default DownloadsV2;
